<form class="lv-artefact-container lv-component"
      [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div class="lv-artefact"
       [ngClass]="{'lv-lesebestaetigung-container': true, 'lv-error-state': !!getError()}">
    <input [name]="'lvHidden'" [(ngModel)]="hiddenInputmodel" class="lv-hidden-form" [required]="uiArtefakt.PflichtfeldJN">
    <div [innerHTML]="uiArtefakt.Titel"></div>
    <div class="lv-lesebestaetigung-button-row">
      <mat-icon *ngIf="!hasDocumentOpened"
                [ngClass]="{'lv-icon-not-downloaded': true, 'lv-icon-error-state': checkbox?.touched &&  !uiArtefakt.WertEingabe}"
                [svgIcon]="'ExclamationCircle'"></mat-icon>
      <mat-icon *ngIf="hasDocumentOpened" class="lv-icon-check" [svgIcon]="'Check'"></mat-icon>
      <button mat-raised-button class="lv-lesebestaetigung-button"
              (click)="onCommand()">
        <span [innerHTML]="uiArtefakt.Label"></span>
      </button>
      <a class="lv-display-none" #downloadLesebestaetigungTrigger></a>
    </div>
    <div class="lv-lesebestaetigung-checkbox-container">
      <mat-checkbox [ngModel]="uiArtefakt.WertEingabe" [required]="uiArtefakt.PflichtfeldJN"
                    [name]="uiArtefakt.Identifikator"
                    #checkbox="ngModel"
                    (blur)="onBlur()"
                    (change)="changeCheckbox($event.checked)" [disabled]="!hasDocumentOpened">
        <div class="lv-lesebestaetigung-checkbox-text" [innerHTML]="uiArtefakt.Text"></div>
      </mat-checkbox>
      <div>
        <mat-error class="lv-error-meldung-style" [ngClass]="uiArtefakt.BreiteInPixel"
                   *ngIf="getError() as error" (click)="onErrorClick()">
          <div class="lv-control-error"
               [ngClass]="{'lv-show-untruncated-error': showUntruncatedError}">{{error}}</div>
        </mat-error>
      </div>
    </div>
    <lv-infotext-permanent
        [InfoTextPermanent]="uiArtefakt.InfoTextPermanent"></lv-infotext-permanent>
  </div>

</form>
